import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-table',
  templateUrl: './note-table.component.html',
  styleUrls: ['./note-table.component.scss']
})
export class NoteTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
